export const infoData = [
  { id: "ready", name: "READY" },
  { id: "unknown", name: "UNKNOWN" },
  { id: "inprogress", name: "IN PROGRESS" },
  { id: "inprogress", name: "IN_PROGRESS" },
  { id: "failed2", name: "FAILED" },
  { id: "txfailed", name: "Tx FAILED" },
  { id: "rxfailed", name: "Rx FAILED" },
  { id: "aborted", name: "ABORTED" },
  { id: "passed2", name: "PASSED" },
  { id: "internalerror", name: "INTERNAL ERROR" },
  { id: "configerror", name: "CONFIG ERROR" },
  { id: "errinforate", name: "ERR: INFO RATE" },
  { id: "errlinerate", name: "ERR: LINE RATE" },
  { id: "blocked", name: "BLOCKED" }
];
